import React from 'react';
import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  current: number;
  total: number;
  showText?: boolean; // Опциональный параметр для отображения текста
  showProgress?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ 
  current, 
  total, 
  showText = false,
  showProgress = true
}) => {
  return (
    <div className={styles.progressContainer}>
      {showText && (
        <div className={styles.progressText}>
          {current}/{total}
        </div>
      )}
      {showProgress && (
        <div className={styles.progressBar}>
        {Array.from({ length: total }, (_, index) => (
          <div 
            key={index}
            className={`${styles.progressSection} ${
              index < current ? styles.completed : ''
            }`}
          />
          ))}
        </div>
      )}
    </div>
  );
};
